import PropTypes from 'prop-types'
import React, { useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { M_StateActions, MTable, LoadingContext } from 'src/M_Components'

export default function RoleConfig({ roles, onCreateTab, toastMessages }) {
    const ctx = useContext(LoadingContext)
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [refresh, setRefresh] = useState(false)
    const removeContextItems = ['Print', 'Copy']

    //============================================================================================================
    // Function to handle creating a new route
    //============================================================================================================
    const NewRoute = (url, label, operation, data) => {
        dispatch(M_StateActions.addM_State({ key: 'operation', value: operation })) // Set the operation state
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') { // Check if the operation is one of the specified types
            if (!data) { // If no role data provided for the specific types, show an error message
                toastMessages('error', '', t("SelectedLine"))
                return
            }
            dispatch(M_StateActions.addM_State({ key: 'rolesLine', value: data })) // Set the roles line state
        }
        if (operation === 'Create') {
            onCreateTab(url, label)
        }
        else if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            onCreateTab(url, `${label} "${data.Name}"`)
        }
    }

    return (
        <div className='divGlobalSettings'>
            <div className='subTitleSettings'>
                <div>
                    <div style={{ color: ctx.secondaryColor }}>
                        {t("Roles")}
                    </div>
                    <div className='labelSubtitleSettings'>
                        {t("InfoPanelRoles")}
                    </div>
                </div>
            </div>
            <MTable // Dynamic table for role management
                entityName={'Profiles'}
                roleName={'Profiles'}
                rolePermissions={roles}
                removeContextItems={removeContextItems}
                refresh={refresh}
                setRefresh={setRefresh}
                useSessionStorage={false}
                replaceFunctions={new Map([
                    ['View', (e) => NewRoute('RoleConfig', t('LabelViewRoles'), 'View', e)],
                    ['Edit', (e) => NewRoute('RoleConfig', t('LabelEditRoles'), 'Edit', e)],
                    ['Create', (e) => NewRoute('RoleConfig', t('LabelCriarRoles'), 'Create', e)]
                ])}
            />
        </div>
    )
}

RoleConfig.propTypes = {
    roles: PropTypes.array,
    onCreateTab: PropTypes.func,
    toastMessages: PropTypes.func,
}
